import { render, staticRenderFns } from "./AddPrescription.vue?vue&type=template&id=3da86d01"
import script from "./AddPrescription.vue?vue&type=script&lang=js"
export * from "./AddPrescription.vue?vue&type=script&lang=js"
import style0 from "./AddPrescription.vue?vue&type=style&index=0&id=3da86d01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports